import Lottie from "lottie-react"
import animationData from "@shared/assets/Loader.json"

interface LoaderProps {
    height?: string
    width?: string
    loop?: boolean
    className?: string
}

export const Loader: React.FC<LoaderProps> = ({
    height = "60px",
    width = "60px",
    loop = true,
    className
}) => {
    return (
        <div
            className={["DSLoader", className].filter(Boolean).join(" ")}
            style={{ height, width, display: "flex" }}
        >
            <Lottie
                animationData={animationData}
                loop={loop}
                style={{ height: "100%", width: "100%", display: "block" }}
                rendererSettings={{ preserveAspectRatio: "xMidYMid meet" }}
            />
        </div>
    )
}
